import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const NetAmountLineChart = ({ data = [] }) => {
  /* ================= RESPONSIVE ================= */
  const isMobile = window.innerWidth < 640;

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          height: 260,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        No Data
      </div>
    );
  }

  /* ================= LABELS ================= */
  const labels = data.map(d =>
    new Date(d.week_start).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short"
    })
  );

  /* ================= SERIES ================= */
  const net = data.map(d => Number(d.net_outstanding_lakh || 0));
  const d90 = data.map(d => Number(d.outstanding_90_days_lakh || 0));
  const d180 = data.map(d => Number(d.outstanding_180_days_lakh || 0));

  /* ================= SCROLL WIDTH ================= */
  const barWidth = isMobile ? 80 : 100; // per week
  const chartWidth = isMobile
    ? Math.max(labels.length * barWidth, window.innerWidth)
    : "100%";

  /* ================= CHART DATA ================= */
  const chartData = {
    labels,
    datasets: [
      {
        type: "bar",
        label: "Net Outstanding",
        data: net,
        backgroundColor: "#4254bc",
        stack: "stack1",
        barThickness: 35
      },
      {
        type: "bar",
        label: ">90 Days",
        data: d90,
        backgroundColor: "#f5a937",
        stack: "stack1",
        barThickness: 35
      },
      {
        type: "bar",
        label: ">180 Days",
        data: d180,
        backgroundColor: "#cc535b",
        stack: "stack1",
        barThickness: 35
      }
    ]
  };

  /* ================= OPTIONS ================= */
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    
   
    plugins: {
      legend: {
        position: "top",
        align: "end",
        labels: {
          boxWidth: 14,
          padding: 12,
          font: {
            size: 10,
            weight: "500"
          }
        }
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: context => {
            const label = context.dataset.label || "";
            const value = context.parsed.y ?? 0;
            return `${label}: ${value.toFixed(2)} L`;
          },
          footer: items => {
            const i = items[0].dataIndex;
            const total = net[i] + d90[i] + d180[i];
            return `Total: ${total.toFixed(2)} L`;
          }
        }
      },
      datalabels: {
        display: ctx => ctx.datasetIndex === 2,
        anchor: "center",
        align: "top",
        offset: 0,
        padding: -10,
        formatter: (_, ctx) => {
          const i = ctx.dataIndex;
          const total = net[i] + d90[i] + d180[i];
          return `${total.toFixed(2)} L`;
        },
        font: {
          weight: "bold",
          size: 8
        },
        color: "#000"
      }
    },
    scales: {
      x: {
        stacked: true,
        categoryPercentage: 0.9,
        barPercentage: 0.95,
        grid: { display: false },
        
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: v => `${v} L`
        },
        title: {
          display: true,
          text: "Amount (Lakh)"
        },
        grid: {
          drawBorder: false
        }
      }
    }
  };

  /* ================= RENDER ================= */
  return (
    <div style={{ position: "relative" }}>
      {/* SCROLL HINT */}
      {isMobile && (
        <div
          style={{
            fontSize: 11,
            color: "#6b6b8a",
            textAlign: "right",
            marginBottom: 4
          }}
        >
          ← Swipe →
        </div>
      )}

      {/* SCROLLABLE CHART */}
      <div
        style={{
          height: 260,
          position: "relative",
          overflowX: isMobile ? "auto" : "hidden",
          overflowY: "hidden",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <div style={{ width: chartWidth, height: "100%" }}>
          <Chart type="bar" data={chartData} options={options} />
        </div>

        {/* RIGHT FADE INDICATOR */}
        {/* {isMobile && (
          <div
            style={{
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              right: 0,
              width: 36,
              height: "100%",
              background:
                "linear-gradient(to left, rgba(255,255,255,0.95), rgba(255,255,255,0))"
            }}
          />
        )} */}
      </div>
    </div>
  );
};

export default NetAmountLineChart;
